var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PxNavigationTab',{attrs:{"navigation-tabs":_vm.navigationTabs,"selected-tab":_vm.innerActiveTab},on:{"update:selectedTab":function($event){_vm.innerActiveTab=$event},"update:selected-tab":function($event){_vm.innerActiveTab=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }